module["exports"] = [
  "com",
  "us",
  "biz",
  "info",
  "name",
  "net",
  "org"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_US/internet/domain_suffix.js
 ** module id = 438
 ** module chunks = 0
 **/